// extracted by mini-css-extract-plugin
export var informationPill = "information-pill_GeC30lbKHLvlPHb_Je4D";
export var informationPillLabel = "information-pill__label_b2TqtxyUbi3_GwMkFOVf";